import React, { useState, useEffect } from "react";
import { Button, Row, Col, Tabs, Spin } from "antd";

import { PlusOutlined, BarsOutlined } from "@ant-design/icons";
import BankInfo from "./BankInfo";
import PosInfo from "./PosInfo";
import TosInfo from "./TosInfo";
import DbsInfo from "./DbsInfo";
import PosCollectionInfo from "./PosCollectionInfo";
import RequestHandler from "util/RequestHandler";

const { TabPane } = Tabs;

const Index = () => {
  const [openBankInfoDrawer, setOpenBankInfoDrawer] = useState(0);
  const [openPOSInfoDrawer, setOpenPOSInfoDrawer] = useState(0);
  const [openTOSInfoDrawer, setOpenTOSInfoDrawer] = useState(0);
  const [openDbsInfoDrawer, setOpenDbsInfoDrawer] = useState(0);
  const [openPosCollectionInfoDrawer, setOpenPosCollectionInfoDrawer] =
    useState(0);
  const [demoInformation, setDemoInformation] = useState(false);
  const [permissions, setPermissions] = useState({
    loading: true,
    modules: [],
  });
  const [activeTabKey, setActiveTabKey] = useState("8");
  const [addButton, setAddButton] = useState({ visible: false });
  useEffect(() => {
    RequestHandler.get("/User/MenuPermissions").then((response) => {
      setPermissions({
        ...response,
        loading: false,
      });
      RequestHandler.get(
        `/Tenant/GetById/${localStorage.getItem("tenantId")}`
      ).then((res) => {
        if (res.isDemo) {
          setDemoInformation(true);
        }
      });
      const screenExistModuleIds = [8];

      setActiveTabKey("8");
    });
  }, []);

  useEffect(() => setActiveAddButton(), [activeTabKey]);

  const bankInfoOnClick = (e) => {
    setOpenBankInfoDrawer((prevState) => prevState + 1);
  };
  const posInfoOnClick = (e) => {
    setOpenPOSInfoDrawer((prevState) => prevState + 1);
  };
  const tosInfoOnClick = (e) => {
    setOpenTOSInfoDrawer((prevState) => prevState + 1);
  };
  const dbsInfoOnClick = (e) => {
    setOpenDbsInfoDrawer((prevState) => prevState + 1);
  };
  const posCollectionInfoOnClick = (e) => {
    setOpenPosCollectionInfoDrawer((prevState) => prevState + 1);
  };

  const setActiveAddButton = () => {
    const buttons = {
      // 1: {
      //   text: "Banka Hesap Ekle",
      //   onClick: bankInfoOnClick,
      //   onRender: () => {
      //     setOpenTOSInfoDrawer(0);
      //     setOpenDbsInfoDrawer(0);
      //     setOpenPOSInfoDrawer(0);
      //     setOpenPosCollectionInfoDrawer(0);
      //   },
      // },
      // 2: {
      //   text: "TÖS Banka Ekle",
      //   onClick: tosInfoOnClick,
      //   onRender: () => {
      //     setOpenBankInfoDrawer(0);
      //     setOpenDbsInfoDrawer(0);
      //     setOpenPOSInfoDrawer(0);
      //     setOpenPosCollectionInfoDrawer(0);
      //   },
      // },
      // 3: {
      //   text: "Dbs Banka Ekle",
      //   onClick: dbsInfoOnClick,
      //   onRender: () => {
      //     setOpenBankInfoDrawer(0);
      //     setOpenTOSInfoDrawer(0);
      //     setOpenPOSInfoDrawer(0);
      //     setOpenPosCollectionInfoDrawer(0);
      //   },
      // },
      // 5: {
      //   text: "POS Rapor Ekle",
      //   onClick: posInfoOnClick,
      //   onRender: () => {
      //     setOpenBankInfoDrawer(0);
      //     setOpenTOSInfoDrawer(0);
      //     setOpenDbsInfoDrawer(0);
      //     setOpenPosCollectionInfoDrawer(0);
      //   },
      // },
      8: {
        text: "POS Tahsilat Banka Ekle",
        onClick: posCollectionInfoOnClick,
        onRender: () => {
          setOpenBankInfoDrawer(0);
          setOpenTOSInfoDrawer(0);
          setOpenDbsInfoDrawer(0);
          setOpenPOSInfoDrawer(0);
        },
      },
    };

    if (buttons[activeTabKey]) {
      setAddButton({
        text: buttons[activeTabKey].text,
        onClick: buttons[activeTabKey].onClick,
        visible: true,
      });
      buttons[activeTabKey].onRender();
    } else {
      setAddButton({
        visible: false,
      });
    }
  };

  const tabOptions = [
    {
      moduleId: 8,
      title: "POS Tahsilat Banka Tanımla",
      children: (
        <PosCollectionInfo addButtonEvent={openPosCollectionInfoDrawer} />
      ),
    },
  ];

  return permissions.loading ? (
    <Row justify="center" align="middle" style={{ height: "100%" }}>
      <Spin />
    </Row>
  ) : (
    <>
      <Row>
        <Col xs={15} lg={20}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <BarsOutlined /> BANKA ERİŞİMİ TANIMLA
          </p>
        </Col>
        <Col xs={9} lg={4}>
          {addButton.visible && (
            <Button
              type="primary"
              onClick={addButton.onClick}
              disabled={demoInformation}
            >
              <PlusOutlined /> {addButton.text}
            </Button>
          )}
        </Col>
      </Row>
      <Row>
        <Col span={2}></Col>
        <Col span={20}>
          <Tabs
            activeKey={activeTabKey}
            onChange={(key) => setActiveTabKey(key)}
          >
            {tabOptions.map((option) => {
              const isModulePermissionExist = permissions.modules.includes(
                option.moduleId
              );
              return (
                <TabPane
                  tab={option.title}
                  key={option.moduleId}
                  disabled={!isModulePermissionExist}
                >
                  {isModulePermissionExist && option.children}
                </TabPane>
              );
            })}
          </Tabs>
        </Col>
        <Col span={2}></Col>
      </Row>
    </>
  );
};

export default Index;
